window.addEventListener('DOMContentLoaded', () => {
  const scrollbarXElements = document.querySelectorAll('.scrollbar-x');

  scrollbarXElements.forEach(element => {
    let isDragging = false;
    let startX;
    let scrollLeft;

    element.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
    });

    element.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const walk = (x - startX) * 2; // Adjust scrolling speed here
      element.scrollLeft = scrollLeft - walk;
			element.style.cursor = 'grabbing';
    });

    element.addEventListener('mouseup', () => {
      isDragging = false;
			element.style.cursor = 'auto';
    });

    element.addEventListener('mouseleave', () => {
      isDragging = false;
			element.style.cursor = 'auto';
    });
  });
});